// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__I1Oq4","Comment__box":"styles_Comment__box__wDD1a","Comment__boxGreen":"styles_Comment__boxGreen__MnLsU"};